import React from 'react'
import { Box, Image } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import { format } from 'date-fns'

import { getDateFormatLocale } from 'utils/getDateFormatLocale'

import { ArticleAuthor, ArticleContentWrapper, ArticleDate, ArticleTitle } from './styles'

type Props = {
  article: Article | null
  isFullWidth?: boolean
  isSimplifiedView?: boolean
}

export const ArticleContent: React.FC<Props> = ({ article, isFullWidth = false, isSimplifiedView = false }) => (
  <>
    <Image
      src={article?.image || '/article-big.png'}
      borderRadius="9px"
      marginX="auto"
      marginBottom={{ base: '20px', lg: '56px' }}
      marginTop={{ lg: '64px' }}
      maxWidth={isFullWidth ? '100%' : '794px'}
      width="100%"
    />
    <Box maxWidth={isFullWidth ? '100%' : '590px'} marginX="auto">
      {!isSimplifiedView && <ArticleTitle>{article?.title}</ArticleTitle>}
      {!isSimplifiedView && <ArticleAuthor>{article?.fullName}</ArticleAuthor>}
      {!isSimplifiedView && (
        <ArticleDate>
          {article && format(new Date(article.createdAt || ''), 'dd.MM.yyyy', { locale: getDateFormatLocale() })}
        </ArticleDate>
      )}

      <ArticleContentWrapper>
        {article?.body && <div dangerouslySetInnerHTML={{ __html: article?.body }} />}
      </ArticleContentWrapper>
    </Box>
  </>
)
